if ($('.id-712').length) {
    var $pageTop = $('<div class="page-top"><div class="container"></div></div>');
    $pageTop.insertAfter('header#header');
    var $container = $pageTop.find('.container');
    var $breadcrumbsWrapper = $('<div class="breadcrumbs-wrapper"></div>');
    $('.breadcrumbs').appendTo($breadcrumbsWrapper);
    $breadcrumbsWrapper.appendTo($container);

    $('h1').first().appendTo($container);
    $('.top-paragraph').appendTo($container);


    $('.top-paragraph .tel')
        .append($('footer#footer .contact-box li span.tel').clone().addClass('telephone'));

    $('.top-paragraph .mail')
        .append($('footer#footer .contact-box li span.mail').clone().addClass('mail'));



    $('.store-wrapper .contact-box .tel')
        .append($('footer#footer .contact-box li span.tel').clone().addClass('telephone'));

    $('.store-wrapper .contact-box .mail')
        .append($('footer#footer .contact-box li span.mail').clone().addClass('mail'));

    $('.store-wrapper .contact-box .socials').append($('footer#footer .contact-box li span.facebook').closest('li').clone());
    $('.store-wrapper .contact-box .socials').append($('footer#footer .contact-box li span.instagram').closest('li').clone());
    $('.store-wrapper .contact-box .socials').append($('footer#footer .contact-box li span.tiktok').closest('li').clone());
    $('.store-wrapper .contact-box .socials').append($('footer#footer .contact-box li span.youtube').closest('li').clone());


}
